export class Seo {
  constructor() {
    const twitterLabel = document.querySelector("[name='twitter:label2']");
    const twitterData = document.querySelector("[name='twitter:data2']");
    
    if(twitterLabel) {
      twitterLabel.remove();
    }

    if(twitterData) {
      twitterData.remove();
    }
  }
}

export default new Seo;

